import { ValidationInputType } from "@cak-legacy/generation-core";
import { AbstractCrossFieldValidation } from "./AbstractCrossFieldValidation";
import { CustomErrorMessage } from "./ValidationHelper";
import { translate } from "../Locales/translator";

export class EqualsValueValidation extends AbstractCrossFieldValidation {
  key = "equalsValue";

  constructor(
    readonly fieldToCheck: string,
    readonly valueToEqual: string,
    customErrorMessage?: CustomErrorMessage
  ) {
    super(customErrorMessage);
  }

  validate = (_input: ValidationInputType) => {
    return this.getValues(this.fieldToCheck) === this.valueToEqual;
  };

  defaultMessage = (label: string): string => 
    translate("Generation_Form_{label}MoetGelijkZijnAan{valueToEqual}", { label: label, valueToEqual: this.valueToEqual });
}
